var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1910_28848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0C41.3137 0 44 2.68629 44 6V17.1553C43.9119 17.1471 43.8227 17.1426 43.7324 17.1426C42.1545 17.1426 40.875 18.422 40.875 20C40.875 21.578 42.1545 22.8574 43.7324 22.8574C43.8227 22.8574 43.9119 22.8519 44 22.8438V34C44 37.3137 41.3137 40 38 40H10C6.68629 40 4 37.3137 4 34V6C4 2.68629 6.68629 1.28851e-07 10 0H38Z",
    fill: "#04B7B1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_28848)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.572 15.94C30.6608 15.9807 30.7303 15.9787 30.828 15.9787H37.4159C37.5374 15.9787 37.6588 15.8772 37.6588 15.7557L38.4311 8.02578C38.491 7.47829 38.3079 6.95075 37.9435 6.56643C37.5374 6.09872 36.8884 5.87572 36.2394 5.97727C35.5904 6.05885 35.0429 6.42323 34.7782 6.97252L30.4563 15.6144C30.4342 15.6596 30.4244 15.7048 30.4268 15.7498C30.4308 15.8244 30.5041 15.9089 30.572 15.94ZM20.9824 15.9787H24.9997C25.0812 15.9787 25.1628 15.9388 25.2027 15.8572C26.3176 14.1731 26.6022 12.0629 26.6838 10.968C26.6838 10.8864 26.6639 10.8266 26.6022 10.765C26.5406 10.7033 26.4608 10.6834 26.3992 10.6834C24.9797 10.765 22.342 11.1711 20.5962 12.8951C20.4892 12.9893 20.3986 13.1017 20.3079 13.216C20.2626 13.2722 20.2191 13.3284 20.1701 13.3827L20.0287 13.564C19.9472 13.6456 19.9472 13.7671 19.9889 13.8486C20.2934 14.4578 20.5363 15.1267 20.7394 15.7957C20.7793 15.8972 20.8609 15.9787 20.9824 15.9787ZM12.9078 15.8771C12.9911 16.0058 13.1884 15.9787 13.3417 15.9787H18.8721C18.9537 15.9787 19.0353 15.9388 19.0752 15.8772C19.1151 15.8174 19.1368 15.7358 19.1151 15.6542C18.7507 14.5393 18.2032 13.6256 17.4925 12.915C15.6869 11.1311 12.846 10.7649 11.7113 10.7051C11.5613 10.7051 11.4267 10.8379 11.4267 10.9879C11.5282 12.3675 11.8527 14.3163 12.9078 15.8771ZM20.8209 29.8959H27.9818C34.5552 29.8959 39.8905 24.5389 39.8905 17.9854C39.8905 17.7226 39.6675 17.4996 39.3847 17.4996H9.4581C9.1753 17.4996 8.95233 17.7026 8.95233 17.9854C8.95233 24.5589 14.2674 29.8959 20.8209 29.8959ZM16.1326 33.9531H32.6678C32.7892 33.9531 32.9125 33.8516 32.9125 33.7102V30.8495C32.9125 30.7679 32.8708 30.6863 32.811 30.6464C32.7494 30.6047 32.6678 30.5848 32.5862 30.6047C31.0851 31.1323 29.5442 31.4169 27.9815 31.4169H20.8205C19.2579 31.4169 17.7151 31.1522 16.2141 30.6047C16.1542 30.5848 16.0527 30.6047 15.9911 30.6464C15.8624 30.7297 15.8895 30.9269 15.8895 31.0802V33.7102C15.8895 33.8317 15.9912 33.9531 16.1326 33.9531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1910_28848",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1910_28848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1910_28848",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_28848"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.95239,
    y: 5.95312,
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationOn);
export default __webpack_public_path__ + "static/media/MedicationOn.8a268be3f5ae947b2284bf1710a30dc6.svg";
export { ForwardRef as ReactComponent };